// extracted by mini-css-extract-plugin
export default {"header":"StaffProfile_header__wBazY","headerRow":"StaffProfile_headerRow__IeoLb","avatar":"StaffProfile_avatar__nuB9U","infoText":"StaffProfile_infoText__YgwM-"};